import baseTheme from "@/themes/baseTheme";
import styled from "styled-components";

export const List = styled.ul`
  list-style: none;
  padding: 0 1rem;
  margin-bottom: 0;

  svg {
    color: ${baseTheme.token.colorPrimary};
    cursor: pointer;
  }
`;
